export const riskLevels = [
  {
    level: 1,
    name: 'Level 1',
    range: '90-100',
    color: 'bg-red-500',
    description: 'Critical risk level requiring immediate action',
    status: 'active',
  },
  {
    level: 2,
    name: 'Level 2',
    range: '70-89',
    color: 'bg-orange-500',
    description: 'High risk level requiring prompt attention',
    status: 'inactive',
  },
  {
    level: 3,
    name: 'Level 3',
    range: '50-69',
    color: 'bg-yellow-500',
    description: 'Moderate risk level requiring monitoring',
    status: 'inactive',
  },
  {
    level: 4,
    name: 'Level 4',
    range: '0-49',
    color: 'bg-blue-500',
    description: 'Low risk level under normal operations',
    status: 'inactive',
  },
];